import React from 'react';
import { UserCheck } from 'lucide-react';

// Yes guests who are allowed a plus-one but never said whether the plus-one is coming.
export default function PlusOneCheck({ guests, onSet }) {
  const open = guests.filter((g) => g.rsvp === 'Yes' && g.plusOne && (g.plusOneComing === null || g.plusOneComing === undefined));
  if (!open.length) return null;
  return (
    <div className="px-4 py-3 bg-[#FFF8E1] border-b border-[#FFE082]" data-testid="plus-one-check">
      <p className="text-sm text-[#7B4A1A] flex items-center gap-2 mb-2"><UserCheck className="w-4 h-4" /> {open.length} plus-one{open.length > 1 ? 's' : ''} to confirm. They count in your headcount until you mark them Not coming.</p>
      <div className="flex flex-wrap gap-2">
        {open.map((g) => (
          <span key={g.id} className="inline-flex items-center gap-2 bg-white rounded-full border border-[#FFE082] pl-3 pr-1 py-1 text-xs" data-testid={`plus-one-check-${g.id}`}>
            {g.name}{g.plusOneName ? ` + ${g.plusOneName}` : ' + guest'}
            <button data-testid={`plus-one-check-yes-${g.id}`} onClick={() => onSet(g.id, { plusOneComing: true })} className="px-2 py-0.5 rounded-full bg-[#7B2C3B] text-white hover:opacity-90">Coming</button>
            <button data-testid={`plus-one-check-no-${g.id}`} onClick={() => onSet(g.id, { plusOneComing: false })} className="px-2 py-0.5 rounded-full border border-[#EFE3D8] hover:border-[#B8896C]">Not coming</button>
          </span>
        ))}
      </div>
    </div>
  );
}
